// src/components/admin/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const accessToken = localStorage.getItem("access"); // Check for access token

  if (!accessToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default PrivateRoute;
